import { RootState } from '../store'

export const settingsSelector = (state: RootState) => {
  const { settings } = state

  return settings
}
